import { FC } from "react";
import { StepThreeConfirmationModalProps } from "./types";




const StepThreeConfirmationModal: FC<StepThreeConfirmationModalProps> = ({ isModalVisible, hideModal, hideModalOnConfirmation }): JSX.Element => {
  return (
    <div
      className={`modal fade ${isModalVisible ? 'show show-modal' : ''}`}
      id="caseConfirmationModal"
      tabIndex={-1}
      data-bs-backdrop="true"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered reminder-modal"
        style={{ maxWidth: '1000px !important' }}
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header px-4 py-3">
            <p className="modal-title fw-bold" style={{fontSize:'1.575rem'}}>
              Reminder!
              <span className="fw-normal d-block" style={{fontSize:'0.992rem'}}>
                Your patient may be missing out on patient support resources for their QUTENZA 
                treatment
              </span>
            </p>
          </div>

          <div className="modal-body px-4 py-3">
            <p className="fw-bold" style={{fontSize:'0.9rem'}}>
              You have not enrolled in the Patient Care Coordinator (PCC) and/or QUTENZA Nurse Specialist 
              program for this patient.
            </p>
            <p className="fw-bold" style={{fontSize:'0.9rem'}}>
              These programs provide no-cost, one-on-one support to help patients understand their coverage,
              know what to expect with treatment, and access support between visits.
            </p>

            <div className="alert alert-primary border border-0" role="alert">
              <p className="fw-bold text-dark" style={{fontSize:'0.99rem'}}>
                If you would like to enroll this patient, please go back and select the 
                program(s) in which you'd like to enroll your patient:
              </p>

              <div className="alert alert-light shadow border-light d-flex gap-3 gap-lg-4">
                <div className="form-check mt-2">
                  <input className="form-check-input p-2" type="checkbox" value="" checked/>
                </div>
                <i className="bi bi-headset fs-4 icon" style={{backgroundColor: '#e5f9ed'}}></i>
                <div>
                  <p className="fw-semibold text-dark mb-0" style={{fontSize: '1.2rem'}}>Patient Care Coordinator</p>
                  <p className="text-dark mb-0 lh-sm" style={{fontSize: '0.85rem'}}>
                    Automatically initiate outreach by a Patient Care Coordinator who will contact the patient
                    directly to provide insurance coverage details specific to treatment with QUTENZA three
                    days after the Benefits Investigation is completed by My QUTENZA Connect. Patients will be
                    asked to provide additional consent to proceed with the program and may opt-out at any time.
                  </p>
                </div>
              </div>
              <div className="alert alert-light shadow border-light d-flex gap-3 gap-lg-4">
                <div className="form-check mt-2">
                  <input className="form-check-input p-2" type="checkbox" value="" checked/>
                </div>
                <i className="bi bi-person fs-4 icon" style={{backgroundColor:'#e8f2fd'}}></i>
                <div>
                <p className="fw-semibold text-dark mb-0" style={{fontSize:'1.1rem'}}>QUTENZA Nurse Specialist</p>
                  <p className="text-dark mb-0 lh-sm" style={{fontSize:'0.85rem'}}>
                    Automatically initiate outreach by a QUTENZA Nurse Specialist who will contact the patient
                    directly to provide education and support specific to treatment with QUTENZA. Patients will be
                    asked to provide additional consent to proceed with the program and may opt-out at any time.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer flex-column">
            <p className="text-center fw-bold w-100 my-3" style={{fontSize:'0.99rem'}}>Would you like to go back and enroll your patient?</p>
            <div className="d-flex flex-column flex-lg-row justify-content-between gap-3 gap-lg-5">
              <button type="button" onClick={hideModal} className="btn btn-blue text-uppercase rounded px-4 py-2">
                Go back & enroll
              </button>
              <button type="button" onClick={hideModalOnConfirmation} className="btn btn-light text-uppercase rounded px-4 py-2">
                Continue without support
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StepThreeConfirmationModal;
